import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on, select } from '@ngrx/store';
import * as Action from './actions'
import { ITower } from 'app/models/tower';
import { from } from 'rxjs';

export interface State extends EntityState<ITower> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
}


export function sortByName(a: ITower, b: ITower): number {
  return a.name.localeCompare(b.name);
}
export function sortByOrder(a: ITower, b: ITower): number {
  const compare = a.order - b.order;
  if (compare > 0) {
    return 1;
  } else if (compare < 0) {
    return -1;
  } else {
    return 0;
  }
}

export function selectId(a: ITower): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<ITower> = createEntityAdapter<ITower>({
  sortComparer: sortByOrder,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  error: ''
});

export const stateName = 'towers';

// Reducers
export const reducer = createReducer<State>(
  initialState,
  on(Action.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),
  on(Action.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),
  on(Action.updateItem, (state, { item }) => {
    return adapter.setOne(item, state);
  }),
  on(
    Action.setItem,
    Action.setItemAndNavigate,
    Action.setItemFromListPage,
    (state, action) => Object.assign({ ...state, selectedId: action.id })),


);


// get the selectors
const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();


const selectState = createFeatureSelector<State>(stateName);

// Export selectAll for effect caching
export { selectAll };

export const getSelectedId = (state: State) => state.selectedId;
const getState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(getState, selectAll);
export const selectAllEntities = createSelector(getState, selectEntities);
export const selectCurrentId = createSelector(getState, getSelectedId);
export const selectCurrentItem = createSelector(selectAllEntities, selectCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);


// // export const selectAllEntities = createSelector(selectState, selectEntities);


